import { configureStore } from "@reduxjs/toolkit";
import  UserManagementSlice  from "./features/UserManagementSlice";
import BannerManagementSlice from './features/BannerManagementSlice'
import ProductCategorySlice from './features/ProductCategorySlice'
import ProductCatalogueSlice from './features/ProductCatalogueSlice'
import CityManagementSlice from './features/CityManagementSlice'
import BookingManagementSlice from './features/BookingManagementSlice'
import PaymentManagementSlice from './features/PaymentManagementSlice'
import AbandonedCartManagmentSlice from './features/AbandonedCartManagmentSlice'
import AuthSlice from './features/AuthSlice'
import ContentManagementSlice from './features/ContentManagementSlice'
import NotifcationManagementSlice from './features/NotificationManagement'
import BookingSlice from './features/BookingHistory'
import  AccountManagementSlice  from "./features/AccountManagement";
import MetaDataManagementReducer from "./features/MetaDataManagementSlice";
import LeadManagementSlice from "./features/LeadManagementSlice";
import EventPageManagementReducer from "./features/EventPageManagementSlice";
import VendorCategoryManagementSlice from "./features/VendorCategoryManagementSlice";
import VendorCityManagementSlice from "./features/VendorCityManagementSlice";
import VendorManagementSlice from "./features/VendorManagementSlice";

const store = configureStore({
  reducer: {
    userManagement: UserManagementSlice,
    bannerManagement:BannerManagementSlice,
    ProductCategory:ProductCategorySlice,
    ProductCatalogue:ProductCatalogueSlice,
    CityManagement:CityManagementSlice,
    BookingManagement:BookingManagementSlice,
    PaymentManagement:PaymentManagementSlice,
    AbandonedCartManagment:AbandonedCartManagmentSlice,
    Auth:AuthSlice,
    ContentManagemnt:ContentManagementSlice,
    Notification:NotifcationManagementSlice,
    Booking:BookingSlice,
    AccountManagement:AccountManagementSlice,
    MetaDataManagement: MetaDataManagementReducer,
    leadManagement:LeadManagementSlice,
    EventPageManagement: EventPageManagementReducer,
    VendorCategoryManagement: VendorCategoryManagementSlice,
    VendorCityManagement: VendorCityManagementSlice,
    VendorManagement: VendorManagementSlice
    },
  });

  export default store;